import { GridAction } from '@eforall/dashboard';
import { Event } from '@interfaces';

export function getActions() {

	const actions: GridAction<Event>[] = [];

	return actions;
}